<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <CForm @submit.prevent="handleSubmit(validateTier), setFocus()">
        <CCard>
          <header class="card-header grey-header d-flex">
            <div class="row flex-flow-column">
              <div v-if="selectedPricingObj">
                <div class="col">
                  <strong
                    >{{
                      $tc(
                        "managePricing.manageTitle",
                        pricingResponse && pricingResponse.length
                      )
                    }}
                  </strong>
                </div>
                <p class="desc">{{ $t("managePricing.manageDesc") }}</p>
              </div>
              <div v-else>
                <div class="col">
                  <strong>{{ $t("managePricing.addTitle") }}</strong>
                </div>
                <p class="desc">{{ $t("managePricing.addDesc") }}</p>
              </div>
            </div>
            <CButton
              v-if="selectedPricingObj || pricingObj"
              @click="navigateToCreatePricing(null)"
              class="btn align-right btn-lit-blue btn-success mob-pricing-new-btn"
              >{{ $t("managePricing.new") }}
            </CButton>
            <!-- <button type="button" class="btn align-right btn-lit-blue btn-success">New Tier</button> -->
          </header>

          <CCardHeader>
            <div v-show="!isEdit">
              <CRow class="mob-flex-flow-c">
                <CCol class="d-flex ai-center">
                  <div class="mob-w-100_30px tier_mt_name">
                    <CRow>
                      <CCol>
                        <label>{{ $t("managePricing.tierName") }}</label>
                      </CCol>
                    </CRow>
                    <CRow>
                      <div class="pricing_title_wrap">
                        <CCol>
                          <h4
                            class="pricing-title"
                            v-if="pricingObj && pricingObj.name"
                          >
                            {{ pricingObj.name }}
                          </h4>
                        </CCol>
                      </div>

                      <CCol class="ai-center d-flex">
                        <div
                          @click="toggleEdit()"
                          v-c-tooltip.hover="{
                            content: 'Rename',
                            active: false,
                          }"
                        >
                          <CIcon color="white" name="cil-pencil" />
                        </div>
                      </CCol>
                      <!--                <CCol v-if='pricingObj' class="d-flex ai-center">-->
                      <!--                  <span :class="{'badge-success': pricingObj.isactive}" class="badge badge-danger"> {{pricingObj.isactive?$t('managePricing.active'): $t('managePricing.inactive')}} </span>-->
                      <!--                </CCol>-->
                    </CRow>
                  </div>
                </CCol>

                <!-- <CCol>
                                  <CButton
                                    @click="navigateToCreatePricing(null)"
                                    class="btn btn-outline-primary"
                                  >{{ $t("managePricing.new") }}</CButton>
                                </CCol>-->
                <CCol v-if="pricingObj" class="text-right">
                  <label class="tier_status">{{
                    $t("managePricing.tierStatus")
                  }}</label>
                  <cStatusButton
                    :defaultStatus="pricingObj.isactive"
                    @change="updateTierStatus"
                    :buttonDesc="$t('managePricing.statusDesc')"
                    :label="{
                      checked: $t('managePricing.activate'),
                      unchecked: $t('managePricing.deactivate'),
                    }"
                  >
                  </cStatusButton>

                  <!-- <button @click="updateTierStatus"  :class="{' status-btn active':!pricingObj.isactive,' status-btn deactive':pricingObj.isactive}"   > {{ pricingObj&&pricingObj.isactive?$t('managePricing.deactivate'): $t('managePricing.activate')}} </button> -->
                  <!-- <CRow v-if="status">
                                      <CCol class="d-flex ai-center mt--8px">
                                        <span class="align-right">{{ $t("managePricing.currStatus") }}</span>
                                      </CCol>
                                      <CCol>
                                        <cDropDown
                                          v-model="status"
                                          url="status"
                                          :isAllowEmpty="false"
                                          :ctrlCode="'value'"
                                          :ctrlName="'name'"
                                          :selValue="status.name"
                                          :isShowCode="false"
                                          :isMultiple="false"
                                          :isSearchable="true"
                                          @input="updateTierStatus"
                                        />
                                      </CCol>
                                    </CRow> -->
                </CCol>
              </CRow>
            </div>

            <div v-if="isEdit">
              <CRow class="mob-600-flex-column ">
                <CCol md="6" sm="12" xs="12">
                  <div v-if="isEdit && pricingObj">
                    <ValidationProvider
                      class="d-flex flex-flow-column"
                      col="8"
                      name="Tier Name"
                      rules="noInitialSpace|required|max:30"
                      v-slot="{ errors }"
                    >
                      <input
                        type="text"
                        class="form-control pricing-title "
                        v-model="pricingObj.name"
                        :placeholder="pricingObj.name"
                        @input="onChangePriObjName"
                      />

                      <div>
                        <span
                          v-if="errors && errors[0]"
                          class="invalid-feedback icon"
                          >{{ errors[0] }}</span
                        >
                        <CAlert v-else-if="alertValue" show color="danger">
                          <div
                            v-if="
                              alertValue &&
                                alertValue.hasOwnProperty('valueList')
                            "
                          >
                            <p
                              v-for="(value, index) in alertValue.valueList"
                              :key="index"
                            >
                              {{ value }}
                            </p>
                          </div>
                          <div
                            v-if="
                              alertValue &&
                                alertValue.hasOwnProperty('codeList')
                            "
                          >
                            <span>{{ $t("cAlert.errorCode") + " : " }}</span
                            ><span
                              v-for="(code, index) in alertValue.codeList"
                              :key="index"
                            >
                              {{ code + " " }}
                            </span>
                          </div>
                          <div
                            v-if="
                              alertValue && alertValue.constructor == String
                            "
                          >
                            <p>
                              {{ alertValue }}
                            </p>
                          </div>
                        </CAlert>
                      </div>
                    </ValidationProvider>
                  </div>
                  <div v-else>
                    <ValidationProvider
                      class="d-flex flex-flow-column"
                      col="8"
                      name="Name"
                      rules="noInitialSpace|required|max:30"
                      v-slot="{ errors }"
                    >
                      <input
                        class="form-control pricing-title rest"
                        ref="pricingName"
                        v-model="newName"
                        :placeholder="$t('managePricing.tierName')"
                        type="text"
                        @input="onChangePriObjName"
                      />
                      <div>
                        <span
                          v-if="errors && errors[0]"
                          class="invalid-feedback icon"
                          >{{ errors[0] }}</span
                        >
                        <CAlert v-else-if="alertValue" show color="danger">
                          <div
                            v-if="
                              alertValue &&
                                alertValue.hasOwnProperty('valueList')
                            "
                          >
                            <p
                              v-for="(value, index) in alertValue.valueList"
                              :key="index"
                            >
                              {{ value }}
                            </p>
                          </div>
                          <div
                            v-if="
                              alertValue &&
                                alertValue.hasOwnProperty('codeList')
                            "
                          >
                            <span>{{ $t("cAlert.errorCode") + " : " }}</span
                            ><span
                              v-for="(code, index) in alertValue.codeList"
                              :key="index"
                            >
                              {{ code + " " }}
                            </span>
                          </div>
                          <div
                            v-if="
                              alertValue && alertValue.constructor == String
                            "
                          >
                            <p>
                              {{ alertValue }}
                            </p>
                          </div>
                        </CAlert>
                      </div>
                    </ValidationProvider>
                  </div>
                </CCol>
                <!-- <CCol  class="d-flex justify-content-end ai-center">
                                  <button
                                    style="margin-right: 10px;"
                                    class="h-40px btn action-c-btn btn-success mw-100px"
                                    type="submit"
                                  >{{ $t("managePricing.save") }}</button>

                                  <button
                                    class="btn action-c-btn btn-danger h-40px mw-100px"
                                    type="button"
                                    @click="navToSetupPricing()"
                                  >{{ $t("managePricing.cancel") }}</button>
                                </CCol> -->
              </CRow>
            </div>
          </CCardHeader>

          <CCardBody class="pt-0px pricing-table">
            <div
              class="placeholder_pricing_label"
              v-if="!isEdit && !pricingResponse.length > 0"
              @click="navigateToCreatePricing(null)"
            >
              <div class="wrapper">
                <div class="image">
                  <img src="@imgPath/img/svg/icons/plus-circle.svg" alt="" />
                </div>
                <div class="text">
                  {{ $t("managePricing.addPrice") }}
                </div>
              </div>
            </div>
            <div
              class="placeholder_pricing_label"
              v-if="isEdit && (!pricingObj || !pricingObj.name)"
            >
              <div class="wrapper">
                <div class="image">
                  <img src="@imgPath/img/svg/icons/plus-circle.svg" alt="" />
                </div>
                <div class="text">
                  {{ $t("managePricing.addTier") }}
                </div>
              </div>
            </div>
            <div v-if="pricingResponse && pricingResponse.length > 0">
              <div class="sub-title">{{ $t("managePricing.pricing") }}</div>
              <CRow>
                <CCol>
                  <ul class="row">
                    <div
                      v-for="(pRes, index) in pricingResponse"
                      :key="index"
                      class="col-12"
                    >
                      <li
                        class="list-group-item d-flex justify-content-between align-items-center setupmanager-row"
                      >
                        <div class="align-left">
                          <div class="pricing-name">
                            {{ pRes.name }}
                          </div>
                          <div class="pricing-des">
                            <!-- <span class>for All routes and classes A, B, H, Y</span> -->
                            <span class> {{ pRes.admin_display_text }} </span>
                          </div>
                        </div>

                        <div class="right-align d-flex">
                          <div
                            class="edit-icon c-pointer"
                            color="info removewrap"
                            @click="navigateToCreatePricing(pRes)"
                            v-c-tooltip.hover="{
                              content: 'Edit',
                              active: false,
                            }"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              height="512pt"
                              viewBox="0 0 512 512"
                              width="512pt"
                              style="fill:#3c4b64;"
                            >
                              <path
                                d="m368 511.957031h-309.332031c-32.363281 0-58.667969-26.304687-58.667969-58.667969v-309.332031c0-32.363281 26.304688-58.667969 58.667969-58.667969h181.332031c8.832031 0 16 7.167969 16 16 0 8.832032-7.167969 16-16 16h-181.332031c-14.699219 0-26.667969 11.96875-26.667969 26.667969v309.332031c0 14.699219 11.96875 26.667969 26.667969 26.667969h309.332031c14.699219 0 26.667969-11.96875 26.667969-26.667969v-181.332031c0-8.832031 7.167969-16 16-16s16 7.148438 16 16v181.332031c0 32.363282-26.304688 58.667969-58.667969 58.667969zm0 0"
                              />
                              <path
                                d="m187.136719 340.820312c-4.203125 0-8.300781-1.664062-11.308594-4.691406-3.796875-3.777344-5.417969-9.21875-4.371094-14.445312l15.082031-75.433594c.617188-3.113281 2.152344-5.953125 4.371094-8.171875l220.953125-220.925781c22.867188-22.871094 60.074219-22.871094 82.964844 0 11.070313 11.070312 17.171875 25.792968 17.171875 41.472656s-6.101562 30.398438-17.195312 41.472656l-220.925782 220.949219c-2.21875 2.238281-5.078125 3.753906-8.171875 4.371094l-75.414062 15.082031c-1.046875.214844-2.113281.320312-3.15625.320312zm75.433593-31.082031h.214844zm-45.609374-52.457031-9.410157 47.144531 47.125-9.429687 217.515625-217.511719c5.035156-5.058594 7.808594-11.734375 7.808594-18.859375s-2.773438-13.804688-7.808594-18.859375c-10.367187-10.390625-27.285156-10.390625-37.714844 0zm0 0"
                              />
                              <path
                                d="m453.332031 134.976562c-4.09375 0-8.191406-1.558593-11.304687-4.695312l-60.332032-60.351562c-6.25-6.25-6.25-16.382813 0-22.632813s16.382813-6.25 22.636719 0l60.328125 60.351563c6.25 6.25 6.25 16.382812 0 22.632812-3.136718 3.117188-7.230468 4.695312-11.328125 4.695312zm0 0"
                              />
                            </svg>
                          </div>
                         <!-- <CButton
                                                    color="info removewrap"
                                                    @click="navigateToCreatePricing(pRes)"
                                                    >{{ $t("managePricing.edit") }}</CButton> -->

                    <div   removed temporarily 
                            class="c-pointer"
                            @click="cloneSelectedPricing(pRes)"
                            v-c-tooltip.hover="{
                              content: 'Clone',
                              active: false,
                            }"
                          >
                            <CIcon color="white" name="cil-clone" size="lg" />
                          </div> 
                          <div
                            v-if="permission && permission.canDelete"
                            @click="setConfirmModalDet(pRes)"
                            class="c-red c-pointer"
                            v-c-tooltip.hover="{
                              content: 'Delete',
                              active: false,
                            }"
                          >
                            <CIcon color="#cd0606" name="cil-trash" size="lg" />
                          </div>
                        </div>
                      </li>
                    </div>
                  </ul>
                </CCol>
              </CRow>
            </div>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-end">
            <div class="d-flex" v-if="!isEdit">
              <button
                style="margin-right: 10px;"
                class="btn action-c-btn btn-danger h-40px mw-100px"
                type="button"
                @click="navToSetupPricing()"
              >
                {{ $t("managePricing.goBack") }}
              </button>
            </div>
            <div class="d-flex" v-if="isEdit">
              <button
                style="margin-right: 10px;"
                class="btn action-c-btn btn-danger h-40px mw-100px"
                type="button"
                @click="navToSetupPricing()"
              >
                {{ $t("managePricing.cancel") }}
              </button>
              <button
                class="h-40px btn action-c-btn btn-success mw-100px"
                type="submit"
              >
                {{ $t("managePricing.save") }}
              </button>
            </div>

            <!--        <button-->

            <!--          class="btn action-c-btn btn-danger"-->
            <!--          type="button"-->
            <!--          @click="navToSetupPricing()"-->
            <!--        >{{ $t("managePricing.goBack") }}</button>-->
          </CCardFooter>
        </CCard>
      </CForm>
    </ValidationObserver>

    <!-- <CAlert v-if="alertValue" show color="danger">
            <div v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p v-for="(value,index) in alertValue.valueList" :key="index">
                    {{value}}
                </p>
            </div>
            <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                <span>{{'ErrorCode: '}}</span><span v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
            </div>
            <div v-if="alertValue&&alertValue.constructor==String">
                <p>
                    {{alertValue}}
                </p>
            </div>
        </CAlert> -->
    <cAlertModal
      v-if="isShowAlertModal"
      :buttonList="modalButton"
      :status="1"
      :show="isShowAlertModal"
      :desc="confirmText"
    ></cAlertModal>

    <cAlertModal
      v-if="showConfirmModal"
      :buttonList="modalButton"
      :status="2"
      :infoTitle="$t('managePricing.delete')"
      :show="showConfirmModal"
      :desc="confirmText"
    ></cAlertModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import router, {
  navigate,
  goBack,
  updateDataEdited,
} from "./../../../router/index";
import { COMPONENT_NAME, PATHNAME } from "./../../../util/constants";
import Logger from "./../../../services/logger";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES,
} from "./../../../config/API_DATA";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage,
} from "../../../util/apiValidate";
import BaseConfiguration from "../../../config/base.js";
import apiGetSimplePricing from "./../../../services/apiGetSimplePricing";
import {
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody,
  cloneData,
} from "../../../util/util";
import cDropDown from "./../../../components/form/cDropDown";
import cTextInputComponent from "./../../../components/form/cTextInputComponent";
import apiCreatePricingTier from "./../../../services/apiCreatePricingTier";
import apiUpdateTier from "./../../../services/apiUpdateTier";
import apiUpdateTierStatus from "./../../../services/apiUpdateTierStatus";
import apiCloneSimplePricing from "./../../../services/apiCloneSimplePricing";
import apiDeleteSimplePricing from "./../../../services/apiDeleteSimplePricing";
import cAlertModal from "./../../../components/form/cAlertModal";

import cStatusButton from "./../../../components/form/cStatusButton";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
// import nb from "./../../translations/validation/nb.json";
// import en from "./../../translations/validation/en.json";

// localize({
//     en: {
//         messages: en.messages
//     },
//     nb: {
//         messages: nb.messages
//     }
// });

export default {
  name: COMPONENT_NAME.MANAGE_SIMPLE_PRICING,

  components: {
    cDropDown,
    cTextInputComponent,
    ValidationProvider,
    cAlertModal,
    cStatusButton,
    ValidationObserver,
  },

  data() {
    return {
      pricingObj: null,
      pricingResponse: [],
      alertValue: null,
      newName: null,
      isEdit: false,
      modalButton: [],
      isShowAlertModal: false,
      showConfirmModal: false,
      confirmText: null,
      // showPricingResponse: false
      status: {
        name: null,
        value: Boolean,
      },
      permission: null,
    };
  },

  methods: {
    // tosetfocus: function(){
    //     this.$refs.pricingName.focus()
    // },

    // tosetfocus(){
    //     this.$refs.pricingName.focus()
    // },

    ...mapActions("sCreatePricing", {
      SET_SELECTED_TIER: "SET_SELECTED_TIER",
      SET_SEL_TIER_NAME: "SET_SEL_TIER_NAME",
      SET_SEL_MARKUP_PRICING: "SET_SEL_MARKUP_PRICING",
    }),

    ...mapActions("sManagePricing", {
      SET_SELECTED_PRICING_TIER: "SET_SELECTED_PRICING",
    }),
    onChangePriObjName() {
      try {
        if (BaseConfiguration.isDebug) console.log("onChangePriObjName");
        updateDataEdited(true);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_SIMPLE_PRICING,
          "error in onChangePriObjName",
          err.toString(),
          "onChangePriObjName",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    formatDate(pDate) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("formatDate");
        if (pDate != null) {
          retValue = this.$options.filters.formatDate(pDate, "DD-MM-YYYY");
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_SIMPLE_PRICING,
          "error in formatDate",
          err.toString(),
          "formatDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    validateTier() {
      try {
        if (BaseConfiguration.isDebug) console.log("validateTier");

        if (this.pricingObj) {
          this.updateTierName(this.pricingObj);
        } else {
          if (this.newName && this.newName != "") {
            this.createPricingTier(this.newName);
          } else {
            this.setFocus();
          }
        }
        updateDataEdited(false);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_SIMPLE_PRICING,
          "error in validateTier",
          err.toString(),
          "validateTier",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      /// return retValue;
    },

    navToSetupPricing() {
      try {
        if (BaseConfiguration.isDebug) console.log("navToSetupPricing");

        navigate(PATHNAME.SETUP_PRICING);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_SIMPLE_PRICING,
          "error in navToSetupPricing",
          err.toString(),
          "navToSetupPricing",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    toggleConfirmModal() {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleConfirmModal");
        this.showConfirmModal = !this.showConfirmModal;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_SIMPLE_PRICING,
          "error in toggleConfirmModal",
          err.toString(),
          "toggleConfirmModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    setConfirmModalDet(pPricingObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("setConfirmModalDet");

        this.modalButton = [
          {
            name: this.$t("managePricing.cancel"),
            func: this.toggleConfirmModal,
            color: "danger",
          },
          {
            name: this.$t("managePricing.yes"),
            func: this.deleteSelectedPricing,
            param: pPricingObj,
            color: "danger",
          },
        ];
        this.confirmText = this.$t("managePricing.deleteInfo", {
          name: pPricingObj.display_text,
        });
        this.toggleConfirmModal();
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_SIMPLE_PRICING,
          "error in setConfirmModalDet",
          err.toString(),
          "setConfirmModalDet",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    showAlert(val) {
      this.alertValue = val;
    },

    showAlertModal(val) {
      this.modalButton = [
        {
          name: this.$t("managePricing.ok"),
          func: this.toggleAlertModal,
          color: "success",
        },
      ];
      this.confirmText = val;

      this.toggleAlertModal();
    },

    toggleAlertModal() {
      this.isShowAlertModal = !this.isShowAlertModal;
    },

    toggleEdit() {
      if (BaseConfiguration.isDebug) console.log("toggleEdit");
      this.isEdit = !this.isEdit;
    },

    async createPricingTier(pTierName) {
      if (BaseConfiguration.isDebug) console.log("createPricingTier");

      try {
        if (pTierName) {
          let createPricingTierReq = apiCreatePricingTier.buildRequest(
            pTierName
          );

          if (createPricingTierReq != null && createPricingTierReq.name) {
            let createPricingTierRes = await apiCreatePricingTier.getResponse(
              createPricingTierReq
            );
            if (VALIDATE_SUCCESS_RES(createPricingTierRes)) {
              let createStatus = createPricingTierRes.data.data;

              if (createStatus) {
                this.pricingObj = createStatus;
                this.SET_SELECTED_PRICING_TIER(
                  JSON.parse(JSON.stringify(this.pricingObj))
                );
                this.status = this.getStatus(this.pricingObj);
                this.toggleEdit();
              }

              this.showAlert(null);
            } else {
              let error = getErrorMessage(createPricingTierRes);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                this.showAlert(getErrorAlertValue(error));
              }
            }
          } else {
            throw "invalid request";
          }
        } else {
          throw "not a valid tier name";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SETUP_PRICING,
          "error in  createPricingTier",
          err.toString(),
          "createPricingTier()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getPricingObj(priObj) {
      if (BaseConfiguration.isDebug) console.log("getPricingObj");
      try {
        let pricingObj;
        if (priObj) {
          pricingObj = JSON.parse(JSON.stringify(priObj));
        }
        return pricingObj;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_SIMPLE_PRICING,
          "error in getPricingObj",
          err.toString(),
          "getPricingObj",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getStatus(priObj) {
      if (BaseConfiguration.isDebug) console.log("getStatus");
      try {
        if (priObj) {
          let status = {
            name: priObj.isactive
              ? this.$t("managePricing.active")
              : this.$t("managePricing.inactive"),
            value: priObj.isactive,
          };
          return status;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_SIMPLE_PRICING,
          "error in getStatus",
          err.toString(),
          "getStatus",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async cloneSelectedPricing(priObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("cloneSelectedPricing");
        // let retValue;

        let cloneRequest = apiCloneSimplePricing.buildRequest(priObj);
        if (cloneRequest) {
          let cloneResponse = await apiCloneSimplePricing.getResponse(cloneRequest);

          if (VALIDATE_SUCCESS_RES(cloneResponse)) {
            this.pricingResponse = await this.getPricingResponseByTierId(
              this.pricingObj
            );

            this.showAlertModal(this.$t("managePricing.cloneSuccess"));
            this.showAlert(null);
          } else {
            let error = getErrorMessage(cloneResponse);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.showAlert(getErrorAlertValue(error));
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_SIMPLE_PRICING,
          "error in cloneSelectedPricing",
          err.toString(),
          "cloneSelectedPricing",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      //  return retValue;
    },

    async deleteSelectedPricing(priObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("deleteSelectedPricing");
        //  let retValue;
        this.toggleConfirmModal();
        let deleteRequest = apiDeleteSimplePricing.buildRequest(priObj);
        if (deleteRequest) {
          let deleteResponse = await apiDeleteSimplePricing.getResponse(
            deleteRequest
          );

          if (VALIDATE_SUCCESS_RES(deleteResponse)) {
            this.pricingResponse = await this.getPricingResponseByTierId(
              this.pricingObj
            );
            this.showAlertModal(this.$t("managePricing.deleteSuccess"));
            this.showAlert(null);
          } else {
            let error = getErrorMessage(deleteResponse);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.showAlert(getErrorAlertValue(error));
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_SIMPLE_PRICING,
          "error in deleteSelectedPricing",
          err.toString(),
          "deleteSelectedPricing",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      //  return retValue;
    },

    async updateTierName(pricingObj) {
      if (BaseConfiguration.isDebug) console.log("updateTierName");

      try {
        let tierRequest = apiUpdateTier.buildRequest(
          JSON.parse(JSON.stringify(pricingObj))
        );
        if (tierRequest) {
          let tierResponse = await apiUpdateTier.getResponse(tierRequest);

          if (VALIDATE_SUCCESS_RES(tierResponse)) {
            /*
                            this.selectedPricingObj.name = pricingObj.name;
                            // this.pricingObj = JSON.parse(
                            //   JSON.stringify(this.selectedPricingObj)
                            // );*/
            this.showAlertModal(this.$t("managePricing.nameUpdated"));
            this.SET_SELECTED_PRICING_TIER(
              JSON.parse(JSON.stringify(this.pricingObj))
            );
            this.toggleEdit();
          } else {
            let error = getErrorMessage(tierResponse);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.showAlert(getErrorAlertValue(error));
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_SIMPLE_PRICING,
          "error in updateTierName",
          err.toString(),
          "updateTierName",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async updateTierStatus() {
      if (BaseConfiguration.isDebug) console.log("updateTierStatus");

      try {
        if (this.pricingObj) {
          let pricingObj = cloneData(this.pricingObj);
          pricingObj.isactive = !pricingObj.isactive;

          let statusRequest = apiUpdateTierStatus.buildRequest(pricingObj);
          if (statusRequest) {
            let statusResponse = await apiUpdateTierStatus.getResponse(
              statusRequest
            );

            if (VALIDATE_SUCCESS_RES(statusResponse)) {
              this.pricingObj = pricingObj;
              this.showAlertModal(
                pricingObj.isactive
                  ? this.$t("managePricing.deactivateStatus", {
                      name: pricingObj.name,
                    })
                  : this.$t("managePricing.activeStatus", {
                      name: pricingObj.name,
                    })
              );
              this.SET_SELECTED_PRICING_TIER(
                JSON.parse(JSON.stringify(this.pricingObj))
              );
            } else {
              let error = getErrorMessage(statusResponse);
              let isJwt = handleJWT(error);
              if (!isJwt) {
                this.showAlert(getErrorAlertValue(error));
              }
            }
          } else {
            throw "invalid request";
          }
        } else {
          throw "invalid status";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_SIMPLE_PRICING,
          "error in updateTierStatus",
          err.toString(),
          "updateTierStatus",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async getPricingResponseByTierId(priObj) {
      let returnValue;

      try {
        let pricingRequest = apiGetSimplePricing.buildRequest(priObj);
        if (pricingRequest) {
          let pricingResponse = await apiGetSimplePricing.getResponse(
            pricingRequest
          );

          if (VALIDATE_SUCCESS_RES(pricingResponse)) {
            returnValue = pricingResponse.data.data.list;
            this.permission = pricingResponse.data.data.permission;
            this.showAlert(null);
          } else {
            let error = getErrorMessage(pricingResponse);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.showAlert(getErrorAlertValue(error));
            }
          }
        } else {
          throw "invalid request";
        }

        return returnValue;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_SIMPLE_PRICING,
          "error in getPricingResponseByTierId",
          err.toString(),
          "getPricingResponseByTierId",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    navigateToCreatePricing(pSelectedPricingObj) {
      if (BaseConfiguration.isDebug) console.log("navigateToCreatePricing");
      try {
        if (pSelectedPricingObj) {
          pSelectedPricingObj = JSON.parse(JSON.stringify(pSelectedPricingObj));
          this.SET_SEL_MARKUP_PRICING(pSelectedPricingObj);
          this.SET_SELECTED_TIER(null);
          this.SET_SEL_TIER_NAME(this.pricingObj);
        } else if (this.pricingObj) {
          this.SET_SEL_MARKUP_PRICING(null);
          this.SET_SELECTED_TIER(this.pricingObj);
          this.SET_SEL_TIER_NAME(this.pricingObj);
        } else {
        }
        if (
          (this.pricingObj && this.pricingObj.tierid) ||
          (pSelectedPricingObj && pSelectedPricingObj.tier_id)
        ) {
          navigate(PATHNAME.CREATE_SIMPLE_PRICING);
        } else throw "not a valid tier id";
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_SIMPLE_PRICING,
          "error in navigateToCreatePricing",
          err.toString(),
          "navigateToCreatePricing",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    setFocus() {
      if (this.$refs.pricingName) {
        this.$refs.pricingName.focus();
      }
    },
  },

  computed: {
    ...mapGetters("sManagePricing", {
      selectedPricingObj: "GET_SELECTED_PRICING",
    }),
    ...mapGetters("sSetupPricing", {
      GET_CLONE_TIER_RESPONSE: "GET_CLONE_TIER_RESPONSE",
    }),
  },

  // mounted() {
  //     if (!this.pricingObj) this.setFocus();
  // },

  async created() {
    if (BaseConfiguration.isDebug) console.log("created");

    try {
      //clone flow
      if (this.GET_CLONE_TIER_RESPONSE) {
        this.pricingObj = JSON.parse(
          JSON.stringify(this.GET_CLONE_TIER_RESPONSE)
        );
      }

      //update flow
      else if (this.selectedPricingObj) {
        this.pricingObj = this.getPricingObj(this.selectedPricingObj);
      }
      //create flow
      else {
        this.toggleEdit();
      }

      if (this.pricingObj != null) {
        this.status = this.getStatus(this.pricingObj);
        this.pricingResponse = await this.getPricingResponseByTierId(
          this.pricingObj
        );
      }
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.MANAGE_SIMPLE_PRICING,
        "error in  Creating pricing object",
        err.toString(),
        "Created",
        LOG_TYPE.ERROR
      );

      Logger.getResponse(body);
    }
  },
  beforeCreate() {
    addClassToBody(COMPONENT_NAME.MANAGE_PRICING);
  },

  beforeDestroy() {
    removeClassBody();
  },
};
</script>
